import kaplay from "kaplay";

export const k = kaplay({
  global: false,
  width: 1080,
  height: 1080,
  letterbox: true,
  background: "#674770",
  debug: false,
});